// components/common/EditModal.js
import DatePicker from "react-datepicker";
import styles from './EditModal.module.css';
import ko from "date-fns/locale/ko";
import { countries } from '../../../../utils/countries/countries';
import { useEffect, useState } from "react";
import { InnocodeButton, InnocodeChip } from "@intsoft/innocode-core";

function EditModal({ title, value, onChange, onClose, onSave, type, options, onDelete }) {

  const [previewUrl, setPreviewUrl] = useState(value?.profile_img_url);
  const CAMERA_ICON = "photo_camera";

  // ✅ 컴포넌트가 처음 렌더링되거나 value가 바뀔 때 previewUrl을 동기화
  useEffect(() => {
    // value.profileImageFile은 File 객체, value.profile_img_url은 문자열 URL
    if (value?.profileImageFile instanceof File) {
      // 새로운 파일이 선택된 경우, 해당 파일로 미리보기 생성
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(value.profileImageFile);
    } else {
      // 기존 URL이나 기본 이미지로 설정
      setPreviewUrl(value?.profile_img_url || "https://cdn-icons-png.flaticon.com/512/149/149071.png");
    }
  }, [value]);


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // ✅ 상태에는 base64 URL 대신 실제 File 객체를 저장
      onChange({ ...value, profileImageFile: file });
    }
  };





  const renderInput = () => {
    switch (type) {
      case "date":
        return (
          <DatePicker
            className={styles.modalInput}
            selected={value ? new Date(value) : null} // string → Date
            onChange={(date) => {
              // Date → YYYY-MM-DD string
              const isoString = date?.toISOString().slice(0, 10);
              onChange(isoString);
            }}
            dateFormat="yyyy-MM-dd"
            locale={ko}
            placeholderText="날짜를 선택하세요"
          />
        );
      case "radio":
        return (
          <div className={styles.radioGroup}>
            {options.map((opt) => (
              <label key={opt.value} className={styles.radioItem}>
                <input
                  type="radio"
                  name="gender"
                  value={opt.value}
                  checked={value === opt.value}
                  onChange={() => onChange(opt.value)}
                />
                {opt.label}
              </label>
            ))}
          </div>
        );
      case "address":
        return (
          <>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>주소</label>
              <input
                className={styles.modalInput}
                type="text"
                value={value?.address || ""}
                onChange={(e) => onChange({ ...value, address: e.target.value })}
              />
            </div>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>상세 주소</label>
              <input
                className={styles.modalInput}
                type="text"
                value={value?.addressDetail || ""}
                onChange={(e) => onChange({ ...value, addressDetail: e.target.value })}
              />
            </div>
          </>
        );
      case "global_address":
        return (
          <>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>국가 (Country)</label>
              <select
                className={styles.modalInput} // 기존 input과 동일한 스타일 적용
                value={value?.country || ""}
                onChange={(e) => onChange({ ...value, country: e.target.value })}
              >
                <option value="" disabled>국가를 선택하세요</option>
                {countries.map(country => (
                  <option key={country.code} value={country.code}>
                    ({country.code}) {country.name.en} 
                  </option>
                ))}
              </select>
            </div>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>주 / 도 (State / Province)</label>
              <input
                className={styles.modalInput}
                type="text"
                value={value?.state || ""}
                onChange={(e) => onChange({ ...value, state: e.target.value })}
              />
            </div>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>도시 (City)</label>
              <input
                className={styles.modalInput}
                type="text"
                value={value?.city || ""}
                onChange={(e) => onChange({ ...value, city: e.target.value })}
              />
            </div>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>주소 1 (Address Line 1)</label>
              <input
                className={styles.modalInput}
                type="text"
                placeholder="도로명 주소, 건물 번호 등"
                value={value?.address || ""}
                onChange={(e) => onChange({ ...value, address: e.target.value })}
              />
            </div>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>주소 2 (Address Line 2)</label>
              <input
                className={styles.modalInput}
                type="text"
                placeholder="아파트, 동/호수 등 (선택 사항)"
                value={value?.addressDetail || ""}
                onChange={(e) => onChange({ ...value, addressDetail: e.target.value })}
              />
            </div>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>우편번호 (Postal / ZIP Code)</label>
              <input
                className={styles.modalInput}
                type="text"
                value={value?.postNumber || ""}
                onChange={(e) => onChange({ ...value, postNumber: e.target.value })}
              />
            </div>
          </>
        );
      case "profile":
        return (
          <div className={styles.profileEditWrapper}>
            <div className={styles.profileImageSection}>
              <label htmlFor="profileImageUpload" className={styles.profileImageLabel}>
                <img
                  src={previewUrl}
                  alt="프로필 이미지"
                  className={styles.profilePreview}
                />
                <div className={styles.editIconButton}>
                  <span className={`material-symbols-outlined ${styles.editIcon}`}>
                    {CAMERA_ICON}
                  </span>
                </div>
              </label>
              <input
                id="profileImageUpload"
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleImageChange}
              />
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>프로필 이름</label>
              <input
                className={styles.modalInput}
                type="text"
                value={value.profile_name || ""}
                onChange={(e) => onChange({ ...value, profile_name: e.target.value })}
              />
            </div>

            <div className={styles.profileLists}>
              <div className={styles.profileColumn}>
                <h4>가입된 서비스</h4>
                {value.service_list && value.service_list.length > 0 ? (
                  <ul className={styles.profileList}>
                    {value.service_list.slice(0, 10).map((serviceName, i) => (
                      // <li key={i}>{serviceName}</li>
                      <InnocodeChip
                        theme={"solid"}
                        type={"assistive"}
                        size={"sm"}
                        label={serviceName}
                      />
                    ))}
                  </ul>
                ) : (
                  <p className={styles.profileEmpty}>가입된 서비스 없음</p>
                )}
              </div>

              <div className={styles.profileColumn}>
                <h4>속한 테넌트</h4>
                {value.tenants && value.tenants.length > 0 ? (
                  <ul className={styles.profileList}>
                    {value.tenants.slice(0, 10).map((tenantName, i) => (
                      <InnocodeChip
                        theme={"solid"}
                        type={"assistive"}
                        size={"sm"}
                        label={tenantName}
                      />
                    ))}
                  </ul>
                ) : (
                  <p className={styles.profileEmpty}>소속 테넌트 없음</p>
                )}
              </div>
            </div>
          </div>
        );
      case "add_profile":
        return (
          <div className={styles.profileEditWrapper}>
            <div className={styles.profileImageSection}>
              <label htmlFor="profileImageUpload" className={styles.profileImageLabel}>
                <img
                  src={previewUrl}
                  alt="프로필 이미지"
                  className={styles.profilePreview}
                />
                <div className={styles.editIconButton}>
                  <span className={`material-symbols-outlined ${styles.editIcon}`}>
                    {CAMERA_ICON}
                  </span>
                </div>
              </label>
              <input
                id="profileImageUpload"
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleImageChange}
              />
              <input
                id="profileImageUpload"
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleImageChange} 
              />
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>프로필 이름</label>
              <input
                className={styles.modalInput}
                type="text"
                value={value.profile_name}
                onChange={(e) => onChange({ ...value, profile_name: e.target.value })}
              />
            </div>
          </div>
        );
      case "password_verify":
        return (
          <>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>비밀번호</label>
              <input
                className={styles.modalInput}
                type="password"
                value={value.currentPw || ""}
                placeholder="비밀번호 입력"
                onChange={(e) => onChange({ ...value, currentPw: e.target.value })}
              />
            </div>
          </>
        );
      default:
        return (
          <input
            className={styles.modalInput}
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={`새로운 ${title}`}
          />
        );
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h1 className={`innocode-typography--headline-md innocode-typography--bold ${styles.contentAreaTitleText}`}>
          {title}
            </h1>
            <InnocodeButton
                theme={"opacity"}
                designType='assistive'
                enablePadding={false}
                iconOnly={true}
                icon={<svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18 17.94 6M18 18 6.06 6" />
                </svg>
                }
                onClick={onClose}
            />
            {/* <h3 className={styles.modalTitle}>{title}</h3>
            <button className={styles.popCloseBtn} onClick={onClose} /> */}
        </div>
        <div className={styles.modalContentBody}>
          {renderInput()}
          <div className={styles.modalButtonRow}>

            <InnocodeButton
              theme="solid"
              designType={type === 'profile' ? 'primary' : 'assistive'}
              backgroundColor={type === 'profile' ? 'var(--status-negative, #f83a3a)' : null} 
              onClick={type === 'profile' ? onDelete : onClose}
            >{type === 'profile' ? '삭제' : '취소'}</InnocodeButton>
            <InnocodeButton 
              onClick={onSave}
            >{type === 'password_verify' ? '확인' : '저장'}</InnocodeButton>
            {/* <button className={styles.cancelBtn} onClick={type === 'profile' ? onDelete : onClose}> {type === 'profile' ? '삭제' : '취소'}</button>
            <button className={styles.saveBtn} onClick={onSave}>{type === 'password_verify' ? '확인' : '저장'}</button> */}
          </div>
        </div>
        
      </div>
    </div>
  );
}

export default EditModal;